import { Content } from 'src/contexts/ContentContext';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { formatPercent } from 'src/utils/numberFormatter';
import { getMetricsDisplay } from 'src/utils/ticketMetricUtils';
import { Permission } from 'src/WebApiController';

import * as styles from './Metrics.css';
import { BulletPoint } from './MetricsDisplay/MetricsDisplay.styled';

export type SaleMainMetricsProps = {
  totalNetProceeds: string | null;
};

export function SaleMainMetrics({ totalNetProceeds }: SaleMainMetricsProps) {
  const hasTotalNetProceedsPermissions = useUserHasAnyOfPermissions(
    Permission.Sales_ViewProceeds,
    Permission.Sales_ViewRecentProceeds
  );
  return totalNetProceeds == null ? (
    hasTotalNetProceedsPermissions ? (
      <Content id={ContentId.NA} />
    ) : null
  ) : (
    <span className={styles.saleMainMetrics}>{totalNetProceeds}</span>
  );
}

export type SaleHeaderMetricsProps = {
  needFulfillment: boolean;
};

export function SaleHeaderMetrics({ needFulfillment }: SaleHeaderMetricsProps) {
  return needFulfillment ? (
    <div className={styles.saleHeaderMetricsContainer}>
      <Content id={ContentId.NeedFulfillment} />
    </div>
  ) : null;
}

export type SaleSubMetricsProps = {
  margin: number | null;
  ticketsFulfilled: number;
  ticketsSold: number;
  percentUnfulfilled: string | null;
  pendingSourcing: number | null;
  addBulletPoint?: boolean;
};

export function SaleSubMetrics({
  margin,
  ticketsFulfilled,
  ticketsSold,
  percentUnfulfilled,
  pendingSourcing,
  addBulletPoint = true,
}: SaleSubMetricsProps) {
  const hasCostMarginPermission = useUserHasAnyOfPermissions(
    Permission.Sales_ViewCostAndMargin
  );

  return (
    <span className={styles.saleSubMetrics}>
      {margin == null ? (
        hasCostMarginPermission ? (
          <Content id={ContentId.NA} />
        ) : null
      ) : (
        <span>{getMetricsDisplay('marg', `${formatPercent(margin)}`)}</span>
      )}
      <BulletPoint addBulletPoint={addBulletPoint} />
      <span>
        {getMetricsDisplay(
          'saleUnfilled',
          `${ticketsFulfilled}/${ticketsSold}`
        )}
      </span>
      {percentUnfulfilled != null && (
        <>
          <BulletPoint addBulletPoint={addBulletPoint} />
          <span>
            {getMetricsDisplay('unfulfilledPercent', percentUnfulfilled)}
          </span>
        </>
      )}
      {pendingSourcing != null && (
        <>
          <BulletPoint addBulletPoint={addBulletPoint} />
          <span>{getMetricsDisplay('pendSrc', `${pendingSourcing}`)}</span>
        </>
      )}
    </span>
  );
}
